var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppDialogManager'),(_vm.isInAppHelpEnabled)?_c('InAppHelp',{attrs:{"isGuidedTutorialOn":_vm.isGuidedTutorialOn,"isFlowBuilder":_vm.isFlowBuilder}}):_vm._e(),_c('GuidedTutorials',{attrs:{"isFlowBuilder":_vm.isFlowBuilder}}),_c('InspirationCenter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }